import { createContext, useContext } from "react";
import Navbar from "../components/navbar/Navbar";
import { SignInContext } from "./SignInProvider";

export const NavbarContext = createContext();

export const NavbarProvider = ({ children }) => {
  const { logOutGoogleUser, user, userPhoto } = useContext(SignInContext);
//console.log(userPhoto);
  return (
    <NavbarContext.Provider value={{}}>
      <Navbar 
      logOutGoogleUser={logOutGoogleUser} 
      user={user?.displayName}
      userPhoto={userPhoto} />
           <div className="flex flex-col   bg-neutral-100">{children}</div>

    </NavbarContext.Provider>
  );
};
